module.exports = __webpack_public_path__ + "static/cointelegraph-logo-22b5955c480922f7055b9684ac6aa5d6.png";